const SysRoleType = {
  ADMIN: 1,
  USER: 2,
  REPORTER: 3
}
export default SysRoleType
